export function CourseDetailPage() {
  return <div>Course Detail - Coming soon</div>;
}
